import { render, staticRenderFns } from "./InformationDialogIcon.vue?vue&type=template&id=2d61e322&scoped=true"
import script from "./InformationDialogIcon.vue?vue&type=script&lang=js"
export * from "./InformationDialogIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d61e322",
  null
  
)

export default component.exports